import moment from "moment";
import React, { useMemo } from "react";
import Accordion from "../../components/accordion";
import { TableListing } from "../../components/AppListing/TableListing";
import { FaEye } from "react-icons/fa";
import Tooltip from "../../components/Tooltip";
import { formatPhoneNumber } from "../../utils/common_lib";

const PatientMedication = React.memo(
  ({
    medications,
    isShowDetail,
    showDetails = true,
    showDialogue = false,
    rightDialogHandler = () => {},
  }) => {
    const cols = useMemo(() => [
        {
          title: "Medication",
          key: "drug",
          colClass: "flex text-left",
          getData: (item) =>
            item?.drug ? (
              <div>
                <strong>{item.drug}</strong>
                <>
                  <br />
                  <strong>Substitution:</strong>{" "}
                  {!item.substitute ? "Not Allowed" : "Allowed"}
                </>
                {item?.days_supply ? (
                  <>
                    <br />
                    <strong>Supply:</strong> {item.days_supply || 0} Days
                  </>
                ) : null}
                {/* {item?.interval_text ? (
                  <>
                    <br />
                    <strong>Frequency:</strong> {item.interval_text || ""}
                  </>
                ) : null}
                {item?.ds_route ? (
                  <>
                    <br />
                    <strong>Route:</strong> {item.ds_route}
                  </>
                ) : null} */}
                {item?.note ? (
                  <>
                    <br />
                    <strong>Sig:</strong>{" "}
                    {item?.note + ". " + item?.additional_sig}
                  </>
                ) : null}
                {item?.pharmacy_notes ? (
                  <>
                    <br />
                    <div className="flex items-center gap-1">
                      <strong>Pharmacy Notes:</strong> {item.pharmacy_notes}{" "}
                      <Tooltip
                        content={
                          <div className="flex flex-col w-full gap-1">
                            <p className="font-bold">
                              Name:{" "}
                              <span className="text-[13px] font-normal">
                                {item?.Pharmacy?.name}
                              </span>
                            </p>
                            <p className="font-bold">
                              Address:{" "}
                              <span className="text-[13px] font-normal">
                                {(item?.Pharmacy?.address1 ||
                                  item?.Pharmacy?.address2) +
                                  ", " +
                                  item?.Pharmacy?.city +
                                  ", " +
                                  item?.Pharmacy?.state}
                              </span>
                            </p>
                            <p className="font-bold">
                              Phone:{" "}
                              <span className="text-[13px] font-normal">
                                {formatPhoneNumber(
                                  item?.Pharmacy?.primary_phone
                                )}
                              </span>
                            </p>
                            <p className="font-bold">
                              Fax:{" "}
                              <span className="text-[13px] font-normal">
                                {formatPhoneNumber(item?.Pharmacy?.primary_fax)}
                              </span>
                            </p>
                          </div>
                        }
                        position="top"
                      >
                        <p
                          className="text-[12px] text-sky-500 cursor-pointer hover:text-sky-700"
                          title="View Pharmacy Details"
                          aria-label="View Pharmacy Details"
                        >{`[View Details]`}</p>
                      </Tooltip>
                    </div>
                  </>
                ) : null}
                <>
                  <div className="flex items-center gap-1">
                    <strong>Prescriber:</strong> {item.updated_by_name}{" "}
                    {/* <Tooltip
                      content={
                        <div className="flex flex-col w-full gap-1">
                          <p className="font-bold">{item.updated_by_name}</p>
                          <p className="font-bold">
                            Gender:{" "}
                            <span className="text-[13px] font-normal">
                              {item?.PrescriberAgent?.sex || "-"}
                            </span>
                          </p>
                          <p className="font-bold">
                            NPI:{" "}
                            <span className="text-[13px] font-normal">
                              {item?.PrescriberAgent?.npi || "-"}
                            </span>
                          </p>
                          <p className="font-bold">
                            DEA:{" "}
                            <span className="text-[13px] font-normal">
                              {(
                                item?.PrescriberAgent?.dea || "-"
                              ).toUpperCase()}
                            </span>
                          </p>
                        </div>
                      }
                      position="top"
                    >
                      <p
                        className="text-[12px] text-sky-500 cursor-pointer hover:text-sky-700"
                        title="View Pharmacy Details"
                        aria-label="View Pharmacy Details"
                      >{`[View Details]`}</p>
                    </Tooltip> */}
                  </div>
                </>
              </div>
            ) : (
              "-"
            ),
        },
        {
          title: "Dispense",
          key: "dispense",
          colClass: "flex text-left",
          getData: (item) =>
            item?.dispense ? `${item.dispense} ${item.dispense_units}` : "-",
        },
        {
          title: "Date",
          colClass: "flex text-left",
          getData: (item) =>
            moment(item?.date_written).isValid()
              ? moment(item.date_written).format("MM/DD/YYYY")
              : "-",
        },
        {
          title: "Refills",
          colClass: "flex text-left",
          getData: (item) =>
            item?.refills && item.refills !== "0" ? item.refills : "-",
        },
      ],
      []
    );

    return (
      <div>
        <Accordion
          title="Medications"
          open={true}
          showCount={true}
          count={medications?.approved_medication?.length || 0}
          showDialogue={showDialogue}
          rightDialogHandler={rightDialogHandler}
          icon={<FaEye className="text-blue-500" />}
        >
          {showDetails ? (
            <TableListing
              listData={medications?.approved_medication || []}
              cols={cols}
              loading={false}
            />
          ) : (
            <div className="flex flex-col gap-1">
              {medications?.approved_medication?.length > 0 ? (
                medications?.approved_medication?.map((item, index) => (
                  <div key={index} className={`flex items-flex-start text-left border-b border-gray-200 ${index%2 === 0 ? 'bg-gray-100' : ''}`}>
                    <p className="text-sm p-2">{index + 1}. {item?.drug}</p>
                  </div>
                ))
              ) : (
                <div>
                  <p>
                    <strong>No Medications Found</strong>
                  </p>
                </div>
              )}
            </div>
          )}
        </Accordion>
      </div>
    );
  }
);

export default PatientMedication;